import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import store from './redux';
import App from './App';
import localforage from 'localforage';

localforage.config({
    driver: localforage.INDEXEDDB
});

// import reportWebVitals from './reportWebVitals';
import './index.less';

const RootContainer = () => (
    <div
        style={{ height: '100%' }}
    >
        <Provider store={store}>
            <Router basename='/'>
                <App />
            </Router>
        </Provider>
    </div>
);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<RootContainer />);

// If you want to start measuring performance in your app, pass a function

// to log results (for example: reportWebVitals(console.log))

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// reportWebVitals(undefined);
